import { mappers } from "../mappers";
import { Api, Client } from "../types";

export const transformGetUsersByCurrentShipperResponse = (
  response: Api.GetUsersByCurrentShipper.Response
): Client.GetUsersByCurrentShipper.Response => ({
  ...response,
  data: { users: mappers.mapToUsers(response.data.users) },
});
